import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue';
import { IntentInfo } from '@/services/billing-utils';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessIntent',
  props: {
  intentInfo: { type: Object as PropType<IntentInfo>, required: true },
},
  setup(__props) {

const props = __props;




const title = computed(() => (!props.intentInfo.error ? i18n.t('label.thank_you') : i18n.t('label.oops')));
const icon = computed(() => (!props.intentInfo.error ? 'mdi-checkbox-marked-circle' : 'mdi-alert'));
const iconColor = computed(() => (!props.intentInfo.error ? 'success' : 'error'));
const subtitle = computed(() => {
  if (!props.intentInfo.isSetup && props.intentInfo.canceled) { return i18n.t('message.invoice_cannot_be_paid'); }
  return undefined;
});


return { __sfc: true,props, title, icon, iconColor, subtitle, PaymentResultSuccessLayout }
}

})